import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import Config from '@/components/Config.vue'
import {i18n,vantLocales,changeStyle,ens,en} from './locale/i18n/i18n'
import Cookie from 'js-cookie'
import { handlerDateToDay,handlerDateToTime , tableDateToDay , onExport , addMonth} from '@/utils'
import deepcopy from "deepcopy";
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'
import Vant from 'vant';
import { Toast ,Dialog} from 'vant'
import {FileIcon} from 'vant-green'
import NavBar from '@/components/NavBar.vue'
import Upload from "@/plugins/Upload"
import Upload2 from "@/plugins/Upload2"
import FieldUpload from "@/plugins/FieldUpload"
import FieldFiles from "@/plugins/FieldFiles"

import WorkFlow from "@/plugins/WorkFlow"
import OrgTreeSelect from "@/plugins/OrgTreeSelect"
import OrgPersonTreeSelect from "@/plugins/OrgPersonTreeSelect"
import {saveLogToLocal} from '@/utils'

import {ImagePreview} from 'vant'

Vue.prototype.ImagePreview = ImagePreview

const isApp = !window.location.pathname.startsWith('/main/')

const apiUrl = Config.apiUrl
const tsApiUrl = Config.tsApiUrl

Cookie.set('apiUrl',tsApiUrl)
axios.defaults.withCredentials = true
axios.defaults.baseURL = isApp?tsApiUrl:apiUrl
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.interceptors.request.use(config=>{
  // config.url = '/api/openApi/'+config.url.substr(5)
	let userId = location.pathname.startsWith('/main')?localStorage.getItem('oguGuid'):localStorage.getItem('tsUserGuid')
	if(userId&&userId.length==32){
		config.headers['userId']
	}
	let auditToken = Cookie.get('auditToken')
	if(!auditToken){
		auditToken = localStorage.getItem('auditToken')
	}
	if(auditToken){
		config.headers['token'] = auditToken
	}
  config.headers['tsToken'] = localStorage.getItem('tsToken')
  // config.headers['apiTime'] = new Date().getTime()
  config.headers['APPID'] = location.pathname.startsWith('/main')?'TS':'TS-APP'
  saveLogToLocal('axios',{url:config.url,headers:config.headers,params:config.params})
  return config
},error=>{
  saveLogToLocal('axios_error',error)
  return Promise.reject(error)
})

Vue.prototype.$axios = axios

const tsHttp = axios.create({
  withCredentials:true,
  headers:{
    // 'userId':localStorage.getItem('oguGuid')
  }
})
tsHttp.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
tsHttp.interceptors.request.use(config=>{
  // config.url = '/api/openApi/'+config.url.substr(5)
  let token = localStorage.getItem('tsToken')
  if(token){
    config.headers['tsToken'] = token
	}
	// alert(Cookie.get('uGuid'))
  let userId = location.pathname.startsWith('/main')?(localStorage.getItem('oguGuid')||Cookie.get('uGuid')):localStorage.getItem('tsUserGuid')
  if(userId&&userId.length==32){
    config.headers['userId'] = userId
	}
	
	let auditToken = Cookie.get('auditToken')
	if(!auditToken){
		auditToken = localStorage.getItem('auditToken')
	}
	if(auditToken){
		config.headers['token'] = auditToken
	}
  config.headers['tsToken'] = localStorage.getItem('tsToken')
  config.headers['apiTime'] = new Date().getTime()
  config.headers['APPID'] = (!location.pathname.startsWith('/main'))?'TS-APP':'TS'
  saveLogToLocal('tsHttp',{url:config.url,headers:config.headers,params:config.params})
  return config
},error=>{
  saveLogToLocal('tsHttp_error',error)
  return Promise.reject(error)
})
tsHttp.defaults.baseURL = tsApiUrl
Vue.prototype.$http = tsHttp

Vue.config.productionTip = false

Vue.prototype.$qs = qs
Vue.prototype.Config = Config
Vue.prototype.i18n = i18n
Vue.prototype.styleEn = location.protocol=='http:'?'true':''

Vue.prototype.$isApp = isApp

vantLocales(i18n.locale)
changeStyle(i18n.locale)
Vue.prototype.$changeLocales=(lang)=>{
  localStorage.setItem('lang',lang)
  i18n.locale=lang
  vantLocales(i18n.locale)
  changeStyle(i18n.locale)
}
if(i18n.locale != 'en'){
	Object.keys(ens).forEach(item=>{
		ens[item] = item
	})
}
Vue.prototype.$ens=ens
Vue.prototype.$en=en
Vue.prototype.Cookie = Cookie
Vue.prototype.deepcopy = deepcopy
Vue.component("Upload",Upload)
Vue.component("Upload2",Upload2)
Vue.component("FieldUpload",FieldUpload)
Vue.component("FieldFiles",FieldFiles)
Vue.component("WorkFlow",WorkFlow)
Vue.component("OrgTreeSelect",OrgTreeSelect)
Vue.component("OrgPersonTreeSelect",OrgPersonTreeSelect)

Vue.use(ElementUI);
Vue.use(Vant)
Vue.use(FileIcon);
Vue.component("NavBar",NavBar)

Vue.prototype.Toast = Toast
Vue.prototype.Dialog = Dialog

Vue.prototype.$handlerDateToDay = handlerDateToDay
Vue.prototype.$handlerDateToTime = handlerDateToTime
Vue.prototype.$tableDateToDay = tableDateToDay
Vue.prototype.$onExport = onExport
Vue.prototype.$addMonth = addMonth
Vue.prototype.$userGuid = localStorage.getItem('tsUserGuid')
Vue.prototype.$userNo = ()=>{return JSON.parse(localStorage.getItem('userInfo')).orgUserGuid}
Vue.prototype.$userIsAdmin = ()=>{return (("5d9b0c865271453ebba0c96add3b629f,8a14255933ad46bd9f3ffa276d828434".indexOf(Vue.prototype.$userNo())>-1)?true:'')}


import VConsole from 'vconsole'
if (Config.dev || (window.location.href && window.location.href.endsWith('VConsole'))) {
  new VConsole()
}

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

const buriedPoint = ()=>{
  console.log('用户:'+Cookie.get('oguGuid'))
  // 项目JS入口文件
  const BeaconAction = require('@/assets/js/tgp_h5_sdk.min.js');
  // 上报成功回调，可根据实际业务调整，这里给到一种打印到控制台的方案
  const success = e => {
    console.log('onReportSuccess : ' + e);
  };
  // 上报失败回调，可根据实际业务调整，这里给到一种打印到控制台的方案
  const fail = e => {
    console.log('onReportFail : ' + e);
  };
  const beacon = new BeaconAction({
    appkey: 'LAHKEXKK2C2152DB', // 数据资源appkey, 必填
    reportUrl: 'https://ubap-report.sany.com.cn/logserver/analytics/upload?tp=js', // 默认为 SAAS 服务的上报地址，私有化客户请在此传入您的上报地址
    versionCode: '', //项目版本, 选填, 不设置会走默认配置
    channelID: '', //渠道, 选填, 不设置会走默认配置
    openid: isApp?JSON.parse(localStorage.getItem('userInfo')).persionId:Cookie.get('oguGuid'), // 用户 id, 选填, 不设置会走默认配置；上报到平台后对应为uid字段
    delay: 5000, // 普通事件延迟上报时间(单位毫秒), 默认 5000(5 秒),选填
    maxDBCount: 10000, // 最大存储条数, 默认 10000(条), 设置区间10000-50000,选填
    sessionDuration: 60 * 1000, // session 变更的时间间隔, 一个用户持续 30 分钟(默认值)没有 任何上报则算另一次 session, 每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒 (ms), 最小值 30 秒, 选填, 不设置会走默认配置
    onReportSuccess: success, // 上报成功回调, 选填, 不设置会走默认配置
    onReportFail: fail, // 上报失败回调, 选填, 不设置会走默认配置
  });

  if(!isApp){
    
    // 一键反馈功能
    const BrowserSize = require('@/assets/js/browser-size.cjs.min.js');
    const demp = new BrowserSize(); // 初始化
    demp.constructor.init({
      id: 66,  // 应用ID必填
      user: Cookie.get('oguUserid'), // 用户域账号  选填
      phoneNumber: '', //用户手机号码  选填
      url: window.origin, // 应用域名 必填
      browserWidth: 1080, // 表单宽度  选填
      browserHeight: 740, // 表单高度  选填
    })
    demp.constructor.start();
  }
}
if(isApp?localStorage.getItem('userInfo'):Cookie.get('oguGuid')){
  buriedPoint()
}else{
  let interval = setInterval(()=>{
    let oguGuid = Cookie.get('oguGuid')
    if(isApp?localStorage.getItem('userInfo'):oguGuid){
      window.clearInterval(interval)
      buriedPoint()
    }
  },1000)
}